<template>
  <div
    class="employee-inner employee-inner-info"
    :class="{'employee-inner-full' : tabActive}"
  >
    <!-- Employee profile -->
    <div class="profile-content">
      <!-- <div v-if="loadData" class="profile-content-load">
        Loading data profile
      </div> -->

      <div class="profile-content-data" :class="{'profile-content-data-load' : loadData}">
        <!-- Highlight Profile -->
        <div class="profile-highlight">
          <div class="profile-highlight-image">
            <div class="highlight-image" :class="{'highlight-image-circle' : !profileData.img_profile}">
              <img :src="profileData.img_profile ? profileData.img_profile : DefaultUserImg" :alt="profileData.name ? profileData.name : ''">
            </div>

            <div class="highlight-identity">
              <p>{{ profileData.name ? profileData.name : "" }}</p>
              <p>{{ profileData.email ? profileData.email : "" }}</p>
            </div>
          </div>

          <div class="profile-highlight-data">
            <table v-if="!loadData">
              <tr>
                <td>EIN</td>
                <td>:</td>
                <td>{{ profileData.ein ? profileData.ein : "" }}</td>
              </tr>
              <tr>
                <td>Work Unit</td>
                <td>:</td>
                <td>{{ profileData.work_unit_name ? profileData.work_unit_name : "" }}</td>
              </tr>
              <tr>
                <td>Department</td>
                <td>:</td>
                <td>{{ profileData.department ? profileData.department : "" }}</td>
              </tr>
              <tr>
                <td>Position</td>
                <td>:</td>
                <td>{{ profileData.position_name ? profileData.position_name.split(',').map(item => item.trim()).filter(item => item !== '').join(', ')  : "" }}</td>
              </tr>
              <tr>
                <td>Effective Date</td>
                <td>:</td>
                <td>{{ profileData.start_working ? formatDate(profileData.start_working, 'date') : "" }}</td>
              </tr>
              <tr>
                <td>Attendance Card</td>
                <td>:</td>
                <td>{{ profileData.id_card_no ? profileData.id_card_no : "" }}</td>
              </tr>
              <tr>
                <td>Employment Status</td>
                <td>:</td>
                <td>{{ profileData.state ? profileData.state : "" }}</td>
              </tr>
            </table>

            <table v-else class="table-load">
              <tr v-for="data in 5" :key="data">
                <td v-for="child in 3" :key="child"><p></p></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Employee presence -->
    <div class="presence-content" :class="{'presence-content-load' : loadData}">
      <div class="content-header">
        <p>Attendance</p>
      </div>

      <div class="content-outer">
        <p class="content-day">{{ attendanceDay ? attendanceDay : "" }}</p>
        <p v-if="attendanceNow" class="content-time"><b v-if="attendanceNow[1]">{{ attendanceNow[1].slice(0, 5) }}</b> - <b v-if="attendanceNow[2]">{{ attendanceNow[2].slice(0, 5) }}</b></p>
        <!-- <p class="content-time"><b>08:00</b> - <b>16:00</b></p> -->

        <div @click="openModal('attendance', true, formatSortMonth(attendanceALL))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
          <p>History</p>
        </div>
      </div>
    </div>

    <!-- Employee leave balance -->
    <div class="balance-content" :class="{'balance-content-load' : loadData}">
      <div class="content-header">
        <p>Leave Balance</p>
      </div>

      <div class="content-outer">
        <table v-if="leaveBalance && !loadData">
          <tr v-for="data in leaveBalance.list_leave" :key="data">
            <td>{{ data.leave_name }}</td>
            <td>:</td>
            <td><b>{{ data.used }}</b>/{{ data.max_qty }} ({{ data.period }})</td>
          </tr>
        </table>

        <table v-if="loadData">
          <tr v-for="data in 6" :key="data">
            <td v-for="child in 3" :key="child"><p></p></td>
          </tr>
        </table>

        <div @click="openModal('leaveBalance', true, leaveBalance.list_period)" class="button-general button-primary" :class="{'button-frezee' : loadData}">
          <p>See All</p>
        </div>
      </div>
    </div>

    <!-- Employee update -->
    <div class="update-content" :class="{'update-content-load' : loadData}">
      <div class="content-header">
        <p>Latest Update</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div v-if="latestUpdate && !loadData" class="notif-container">
          <div v-for="data in latestUpdate" :key="data" class="notif-update-content">
            <p>{{ data.title }}</p>
            <p> <span v-html="data.info"></span></p>
            <p>{{ formatDate(data.createdat, 'date') }}</p>
          </div>
        </div>

        <div v-if="loadData" class="notif-container">
          <div v-for="data in 5" :key="data" class="notif-update-content"></div>
        </div>

        <div class="buttons-container">
          <div @click="openModal('latestUpdate', true, formatList(latestUpdatefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
            <p>See All</p>
          </div>
        </div>
      </div>
    </div>

    <ListInfo :loadData="loadData" :setup-panel="punishmentList" @open-detail="openDetail('punishment', $event)" @open-modal="openModal('single', $event)" />
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import DefaultUserImg from '@/assets/general/usericon.png'

  import ListInfo from "../EmployeeInfo/ListInfo.vue"

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: true },
      loadData: { type: Boolean, default: false },
      thisMonthnow: { type: String, default: "" },
      attendanceDay: { type: String, default: "" },
      attendanceNow: { type: String, default: {} },
      attendanceData: { type: Object, default: {} },
      attendanceALL: { type: Object, default: [] },
      leaveBalance: { type: Object, default: {} },
      latestUpdate: { type: Object, default: [] },
      latestUpdatefull: { type: Object, default: [] },
      profileData: { type: Object, default: {} },
      punishmentPayroll: { type: Object, default: [] },
      punishmentPayrollfull: { type: Object, default: [] },
      punishmentPerfomance: { type: Object, default: [] },
      punishmentPerfomancefull: { type: Object, default: [] },
      punishmentPosition: { type: Object, default: [] },
      punishmentPositionfull: { type: Object, default: [] },
      punishmentTerminated: { type: Object, default: [] },
      punishmentTerminatedfull: { type: Object, default: [] }
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const punishmentList = ref({})

      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      const shortDaysId = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]
      const shortDaysEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      function formatDate(date, type) {
        const day = new Date(date).getDate()
        const month = new Date(date).getMonth()
        const year = new Date(date).getFullYear()
        const dayOfWeek = new Date(date).getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
            return `${days[dayOfWeek]}, ${day} ${months[month]} ${year}`
        }
        else if(type == 'date') {
            return `${day} ${months[month]} ${year}`
        }
        else if(type == 'day') {
            return `${day}`
        }
        else if(type == 'shortDay') {
            return `${daysShort[dayOfWeek]}`
        }
      }


      const formatSortMonth = (data) => {
        const sortedMonths = data.sort((a, b) => b.month_number - a.month_number)
        return sortedMonths
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.forEach(item => {
          const dateObj = new Date(item.createdat)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }


      const openModal = (type, status, data) => {
        if(type == 'single') {
          emit("open-modal", status)
        } else {
          emit("open-modal", {type, status, data})
        }
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.punishmentPayroll ||
          props.punishmentPayrollfull ||
          props.punishmentPerfomance ||
          props.punishmentPerfomancefull ||
          props.punishmentPosition ||
          props.punishmentPositionfull ||
          props.punishmentTerminated ||
          props.punishmentTerminatedfull
        ) {
          punishmentList.value = {
            id: "punishment_container",
            title: "Punishment",
            month: null,
            child: [
              {
                id: "punishmentPayroll",
                title: "Consider in Payroll",
                container_color: 'yellow',
                dataShow: props.punishmentPayroll,
                dataFull: props.punishmentPayrollfull
              },
              {
                id: "punishmentPerfomance",
                title: "Consider in Perfomance",
                container_color: 'green',
                dataShow: props.punishmentPerfomance,
                dataFull: props.punishmentPerfomancefull
              },
              {
                id: "punishmentPosition",
                title: "Relate to Position",
                container_color: 'yellow',
                dataShow: props.punishmentPosition,
                dataFull: props.punishmentPositionfull
              },
              {
                id: "punishmentTerminated",
                title: "Is Terminated",
                container_color: 'red',
                dataShow: props.punishmentTerminated,
                dataFull: props.punishmentTerminatedfull
              }
            ]
          }
        }
      })

      return {
        DefaultUserImg,
        formatDate,
        formatSortMonth,
        formatList,
        openModal,
        openDetail,
        punishmentList
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
